<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-card-text class="text-center">
          <img
            class="pt-3 mb-5"
            alt="Noisypeak Logo"
            src="/images/logo.png"
          >
          <div
            v-if="error"
            class="text-center"
            style="color: red;"
          >
            Invalid token
          </div>
          <v-text-field
            v-model="token"
            label="Admin Token"
            counter="32"
            :rules="[rules.required]"
            required
          />
          <v-btn
            large
            block
            :disabled="isLoaded || !isFormValid"
            class="mb-4"
            color="success"
            @click="onSubmit"
          >
            Sign In
          </v-btn>
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SignIn',
    metaInfo: {
      title: 'Sign In',
    },
    data () {
      return {
        token: '',
        error: '',
        isLoaded: false,
        rules: {
          required: (value) => !!value || 'Required',
        },
      }
    },
    computed: {
      isFormValid () {
        return this.token.length >= 32
      },
    },
    methods: {
      onSubmit () {
        this.isLoaded = true
        this.$store.dispatch('login', this.token)
          .then(() => {
            this.$router.push({ name: 'ChannelsPage' })
          })
          .catch((errorMsg) => {
            this.error = errorMsg
          })
          .finally(() => {
            this.isLoaded = false
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
.page-wrap {
    background-image: url('/images/auth_back.jpeg');
    display: flex;
    align-items: center;
    padding: 40px 1rem;
    height: 100%;
    min-height: 100vh;
}
.session-form-hold {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
}
</style>
